var _defs, _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgViewHidden = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Girl",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 678 450",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9c9c9c;}.cls-2{fill:none;stroke:#9c9c9c;stroke-miterlimit:10;stroke-width:20px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "View closed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M591.75,215C587.17,208.78,478.19,61.84,339,61.84S90.82,208.78,86.25,215a16.9,16.9,0,0,0,0,19.92c4.57,6.26,113.56,153.2,252.75,153.2s248.17-147,252.75-153.2A16.9,16.9,0,0,0,591.75,215ZM339,354.41c-102.53,0-191.33-97.54-217.62-129.42C147.63,193.08,236.25,95.59,339,95.59c102.52,0,191.32,97.52,217.61,129.42C530.36,256.92,441.75,354.41,339,354.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339,123.73A101.28,101.28,0,1,0,440.27,225,101.39,101.39,0,0,0,339,123.73Zm0,168.79A67.52,67.52,0,1,1,406.51,225,67.6,67.6,0,0,1,339,292.52Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 83,
    y1: 388.16,
    x2: 595,
    y2: 61.84
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgViewHidden);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/view_hidden.aefd4091dd27f26d7c4a452aae137ee1.svg";